import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import {
  Http,
  RequestOptions,
  Headers,
  RequestOptionsArgs
} from "@angular/http";
import { Storage } from "@ionic/storage";
import { ConfigurationService } from "ionic-configuration-service";

/*
  Generated class for the WaybillOrderServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class DriverServiceProvider {
  public data: any;

  public token: any;

  constructor(
    private configurationService: ConfigurationService,
    public http: Http,
    private storage: Storage
  ) {}

  load_driver_list() {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });

        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
              "api/v0.2/backoffice/drivers",
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      }); //jwt_promise end
    });
  }

  load_driver_map() {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
              "api/v0.2/backoffice/driversMap",
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      }); //jwt_promise end
    });
  }

  load_driver_list_by_client() {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .get(
            this.configurationService.getValue<string>(
              "CLIENTPORTAL_ENDPOINT"
            ) + "stats/get_drivers_list",
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      }); //jwt_promise end
    });
  }

  assignClientToDriver(clientId, driverId) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        //headers.append('Authorization', 'Bearer ');
        let options = new RequestOptions({ headers: headers });

        this.http
          .get(
            this.configurationService.getValue<string>(
              "CLIENTPORTAL_ENDPOINT"
            ) + "stats/assign_driver_to_client",
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            console.log("driver is assigned to client");
            console.log(data);
            resolve(data);
          });
      }); //jwt_promise end
    });
  }

  assignDriverToEcommerce(ecommerceId, driverId) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let param = { ecommerceId: ecommerceId, uid: driverId };
        console.log("params:" + JSON.stringify(param));
        this.http
          .post(
            this.configurationService.getValue<string>("API_ENDPOINT") +
              "api/v0.2/backoffice/clients/assignDriver",
            param,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            console.log(data);
            resolve(data);
          });
      });
    });
  }

  getCollectionPoints() {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
              "api/v0.2/backoffice/collectionPointsMap",
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      }); //jwt_promise end
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/dvm/driver-service.ts